import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Typography } from '@mui/material';
import { FaMoneyBillWave, FaTools, FaChartLine } from 'react-icons/fa';
import UnderConstruction from '../../../components/UnderConstruction';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { useAuthStore } from '../../../auth/state';
import './fin_man_dashboard.css';

// # Helper function to get display name - moved outside component
const getDisplayName = (userProfile, user) => {
  let name = '';
  let username = '';

  // Get name
  if (userProfile?.lastName) {
    name = `${userProfile.lastName}`;
  } else if (userProfile?.firstName) {
    name = `${userProfile.firstName}`;
  } else {
    name = `${user?.email?.split('@')[0] || 'Financial Manager'}`;
  }

  // Get username
  if (userProfile?.username) {
    username = `@${userProfile.username}`;
  }

  return { name, username };
};

// # Helper function to get profile photo URL - moved outside component
const getProfilePhotoUrl = (userProfile) => {
  try {
    if (!userProfile?.photoURL) return '/icons/pfp.png';
    if (userProfile.photoURL === '') return '/icons/pfp.png';
    
    // Check if it's a full URL (from Storage)
    if (userProfile.photoURL.startsWith('http')) {
      return userProfile.photoURL;
    }
    
    // If it's just a filename, assume it's the default
    return '/icons/pfp.png';
  } catch (error) {
    console.error('Error getting profile photo:', error);
    return '/icons/pfp.png';
  }
};

// # Financial Manager Dashboard component
const FinancialManagerDashboard = () => {
  const navigate = useNavigate();
  const { user, userProfile } = useAuthStore();

  // # Memoize display name to prevent unnecessary recalculations
  const displayName = React.useMemo(() => 
    getDisplayName(userProfile, user), [userProfile, user]);

  return (
    <div className="fin_man_dsh_container">
      {/* # Use shared header component */}
      <DashboardHeader />

      {/* # Cover Image */}
      <div className="fin_man_dsh_cover-section">
        <img 
          src="/icons/cover_ocean.jpg" 
          alt="Cover" 
          className="fin_man_dsh_cover-image"
        />
        
        {/* # Title Logo */}
        <div className="fin_man_dsh_title-logo">
          <FaChartLine />
          <h1>Financial Portal</h1>
        </div>
      </div>

      {/* # Profile Section */}
      <div className="fin_man_dsh_profile-section">
        <div 
          className="fin_man_dsh_profile-image-container"
          onClick={() => navigate('/financial-manager-dashboard/profile')}
        >
          <img 
            src={getProfilePhotoUrl(userProfile)}
            alt="Profile" 
            className="fin_man_dsh_profile-image"
          />
        </div>
        <div className="fin_man_dsh_profile-info">
          <h2 className="fin_man_dsh_profile-name">
            {displayName.name}
          </h2>
          <div className="fin_man_dsh_user_username">
            {displayName.username}
          </div>
        </div>
      </div>
      
      <div className="fin_man_dsh_content">
        <Paper className="fin_man_dsh_paper">
          <Typography variant="h5" className="fin_man_dsh_title">
            <FaMoneyBillWave size={24} /> Financial Manager Dashboard
          </Typography>
          
          {/* # Use the UnderConstruction component */}
          <UnderConstruction pageName="Financial Manager Dashboard" />
        </Paper>
      </div>
      
      <DashboardFooter />
    </div>
  );
};

export default FinancialManagerDashboard; 